module.exports = __webpack_public_path__ + "static/media/flora-y-fauna.f151ea8e.jpg";